// ABOUTME: The 2B cloud stack's build: when each tier and puff enters, how long it runs, and which motion it uses.
// ABOUTME: Applied the way settleFade.ts applies the 3A fades: the keyframe name through sx, delay and duration inline.

import { keyframes } from '@emotion/react';
import type { TierId } from './stackGeometry';

// One tier's or puff's entrance: which motion, when it starts and how long it runs, in seconds from the moment 2B is in the page.
export interface StackBuildStep { motion: 'stack' | 'pop'; delay: number; duration: number }

const stackIn = keyframes`
  from { opacity: 0; transform: translateY(12px) scale(0.85); }
`;
const popIn = keyframes`
  from { opacity: 0; transform: scale(0.9); }
  70% { opacity: 1; }
  to { transform: scale(1); }
`;

const PUFF_SEC = 0.4;
export const TIER_BUILD: Record<TierId, StackBuildStep> = {
  base: { motion: 'stack', delay: 0.13, duration: 0.44 },
  lower: { motion: 'pop', delay: 0.57, duration: 0.32 },
  upper: { motion: 'stack', delay: 1.18, duration: 0.44 },
  head: { motion: 'stack', delay: 1.84, duration: 0.44 },
};
export const LOBE_BUILD: Record<string, StackBuildStep> = {
  L7: { motion: 'stack', delay: 0.88, duration: PUFF_SEC }, L8: { motion: 'stack', delay: 0.88, duration: PUFF_SEC },
  L5: { motion: 'stack', delay: 1.53, duration: PUFF_SEC }, L6: { motion: 'stack', delay: 1.53, duration: PUFF_SEC },
  L3: { motion: 'stack', delay: 2.18, duration: PUFF_SEC }, L4: { motion: 'stack', delay: 2.18, duration: PUFF_SEC },
  L1: { motion: 'stack', delay: 2.4, duration: PUFF_SEC }, L2: { motion: 'stack', delay: 2.4, duration: PUFF_SEC },
};
// The build is over when this puff's animation ends: it starts last and ends with L2, at 2.8 s.
export const LAST_PUFF_ID = 'L1';
// The build plays only on these screens; leaving them (to 3A) ends it for good.
export const BUILD_SCREENS = new Set(['2B', '2C', '2D']);

export const stackBuildSx = (step: StackBuildStep) => ({
  animationName: `${step.motion === 'pop' ? popIn : stackIn}`, animationTimingFunction: 'ease', animationFillMode: 'both',
});
export const stackBuildStyle = (step: StackBuildStep) => ({ animationDuration: `${step.duration}s`, animationDelay: `${step.delay}s` });
